import { useUnit } from 'effector-react';
import classNames from 'classnames';
import { Button, ButtonSize, ButtonType, getButtonSizeFromString } from '@nx-frontend/shared/ui/button';
import { closeModalEvent } from '@nx-frontend/shared/ui/modal';
import { useHotKey } from '@nx-frontend/shared/hooks';
import { webnotesThemeColors, webnotesThemeStyle } from '@nx-frontend/shared/themes/webnotes';
import { DialogPopupPayload } from '@nx-frontend/shared/types';

export interface DialogPopupProps {
  content: DialogPopupPayload;
  usePadding?: boolean;
}

export function DialogPopup(props: DialogPopupProps) {
  const closeModal = useUnit(closeModalEvent);
  useHotKey('Enter', function onEnter() {
    // execute main button action if exists
    const mainButton = props.content.buttons.find((button) => button.main);
    if (mainButton && mainButton.onClick) {
      mainButton.onClick();
    }
  });

  const { text, buttons } = props.content;
  const buttonsComponents = buttons.map((button, i) => {
    const onClick = button.onClick || closeModal;
    const size = button.size ? getButtonSizeFromString(button.size) : ButtonSize.SM;

    return (
      <Button
        key={'button-' + i}
        type={button.main ? ButtonType.PRIMARY : ButtonType.STROKED}
        size={size}
        onClick={onClick}
        themeColors={props.content.themeColors ?? webnotesThemeColors}
        themeStyle={props.content.themeStyle ?? webnotesThemeStyle}
        className={classNames('!px-3', button.classes)}
      >
        {button.text}
      </Button>
    );
  });
  return (
    <div className="max-w-[540px]">
      <div
        className={classNames(
          (props.usePadding ?? true) && 'py-4',
          'flex items-center justify-center basis-full w-full text-sm'
        )}
      >
        {text}
      </div>
      <div className="dialog-popup-buttons-wrapper flex flex-row justify-end gap-2 flex-wrap">{buttonsComponents}</div>
    </div>
  );
}
